let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1oiUi")).then(() => parcelRequire('izs5Q'));